import React, { useEffect, useState } from "react";
import BriefingTable from "../subcomponents/table";
import { TextField } from "../subcomponents/fields";
import { TextField as DriversTextField } from "components/DriverReservations/subcomponents/fields";

import { fetchBriefingDocument, fetchRows as fetchData, fetchRPMDocumentBlob, uploadBriefingDocument } from "../helpers";
import { CRUDRow } from "../helpers";
import Actions from "../subcomponents/actions";  // Fixed typo (Actoins -> Actions)
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import HistoryViewer from "../subcomponents/historyViewer";

const MiscNotes = () => {
    const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const briefing = useSelector((state) => state.briefing.line);
    const startDate = useSelector((state) => state.archiveSearch.startDate);
    const endDate = useSelector((state) => state.archiveSearch.endDate);
    const searchTerm = useSelector((state) => state.archiveSearch.searchTerm);

    const requestPayload = {
        "startDate": startDate,
        "endDate": endDate,
        "searchTerm": searchTerm
    }

    const DataURL = "admin/briefing/get_misc_notes";
    const RowURL = "admin/briefing/misc_note_row";

    const handleFileUploadClick = (rowID) => {
        document.getElementById(`document-uploader-${rowID}`).click();
    }

    useEffect(() => {
        (async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            const data = await fetchData(DataURL, briefing, requestPayload);
            setData(data);
        })();
    }, [refresh, startDate, endDate, searchTerm, briefing]);

    // Function to create a new row and refresh the table
    const lCrudRow = async (action = "create", rowID = null) => {
        await CRUDRow(RowURL, action, rowID);
        // Re-fetch data after modifying the row
        const data = await fetchData(DataURL, briefing);
        setData(data);
    };

    const headers = [
        "ID",
        "Pro #",
        "Notes",
        "Attachments",
        'Act.'
    ];

    const renderRow = (row) => (
        <>
            <tr key={row.id}>
                <td className="row-id-cell">
                    <div className="row-id-div">
                        {row.id}
                    </div>
                </td>
                <td style={{ width: "15%" }}>
                    <DriversTextField field={row.pro} trackShift={true}/>
                </td>
                <td>
                    <TextField field={row.note} />
                </td>
                <td style={{ width: "15%" }}>
                    {!row.attachments || row.attachments.length === 0 ? (
                        <div className="fixed-input">No Attachments Uploaded Yet</div>
                    ) : (
                        row.attachments.map((attachment, index) => (
                            <a
                                key={index}
                                className="href"
                                onClick={() => fetchBriefingDocument(attachment.id)}
                                title={attachment.document_name}  // Shows full name on hover
                            >
                                {attachment.document_name.length > 20
                                    ? attachment.document_name.slice(0, 20) + '...'
                                    : attachment.document_name}
                            </a>
                        ))
                    )}
                </td>
                <td className="actions-cell">
                    <Actions
                        onDelete={() => lCrudRow("delete", row.id)}
                        onArchive={() => lCrudRow("archive", row.id)}
                        onAdd={() => handleFileUploadClick(row.id)}
                    />
                    <input
                        style={{ display: "none" }}
                        id={`document-uploader-${row.id}`}
                        type="file"
                        multiple
                        accept=".jpeg,.jpg,.pdf,.png"
                        onChange={(event) => {
                            uploadBriefingDocument(event, RowURL, row.id)
                            setRefresh(!refresh)
                        }
                        }
                    />
                </td>
            </tr>
        </>
    );

    if (briefing === "Old Briefings" && !data.length) {
        return null
    }

    return (
        <>
            <div className="table-header">
                <h2>
                    Miscellaneous Notes
                </h2>
                <HistoryViewer
                    url={DataURL}
                />
            </div>
            <BriefingTable
                headers={headers}
                rows={data}
                renderRow={renderRow}
                createRow={lCrudRow}
            />
        </>
    );
};

export default MiscNotes;
